import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import TextBox from 'devextreme-react/text-box';
import data from '../assets/apiRoutes.json';
import { Button } from 'devextreme-react/button';
import notify from 'devextreme/ui/notify';
import { LoadPanel } from 'devextreme-react/load-panel';
import AccordionReact from 'devextreme-react/accordion';
import Toolbar, { Item } from "devextreme-react/toolbar";
import SelectBox from 'devextreme-react/select-box';
const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];
const availableDate = [
  {
    ID: '0',
    Name: 'SELECT DATE',
  }
];
const availableTimes = [
  {
    ID: '0',
    Name: 'SELECT TIME',
  }
];
const UnScheduleAppointment = (props) => {
  const { id } = useParams();
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [isButtonVisible, setButtonVisible] = useState(true);
  const [isScheduleAppointmentCollapsed, setIsScheduleAppointmentCollapsed] = useState(false);
  const [isShipmentTypeCollapsed, setIsShipmentTypeCollapsed] = useState(true);
  const [isConsigneeCollapsed, setIsConsigneeCollapsed] = useState(true);
  const [isWarehouseCollapsed, setIsWarehouseCollapsed] = useState(true);
  const [isCarrierCollapsed, setIsCarrierCollapsed] = useState(true);
  const [isDetailsCollapsed, setDetailsCollapsed] = useState(true);
  const [loadIndicatorVisible, setLoadIndicatorVisible] = useState(false);
  const [buttonText, setButtonText] = useState('UnSchedule');
  const [loadPanelVisible, setLoadPanelVisible] = useState(false);
  const [showIndicator, setShowIndicator] = useState(true);
  const [shading, setShading] = useState(true);
  const [showPane, setShowPane] = useState(true);
  const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
  const position = { of: '#accordion-containe2' };
  const [transactionNumber, setTransactionNumber] = useState('');
  const [shipperBol, setShipperBol] = useState('');
  const [delDateFrom, setDelDateFrom] = useState('');
  const [delDateTo, setDelDateTo] = useState('');
  const [loadInfo, setLoadInfo] = useState('');
  const [consignee, setConsignee] = useState('');
  const [consigneeAddress1, setConsigneeAddress1] = useState('');
  const [consigneeAddress2, setConsigneeAddress2] = useState('');
  const [consigneeModelFullAddress, setConsigneeModelFullAddress] = useState('');
  const [checkIn, setCheckIn] = useState('');
  const [checkOut, setCheckOut] = useState('');
  const [actualDeliveryDate, setActualDeliveryDate] = useState('');
  const [actualDeliveryTime, setActualDeliveryTime] = useState('');
  const [appointmentDates, setAppointmentDates] = useState('');
  const [appointmentDate, setAppointmentDate] = useState(availableDate[0]);
  const [appointmentTimes, setAppointmentTimes] = useState();
  const [appointmentTime, setAppointmentTime] = useState(availableTimes[0]);
  const [planWarehouseId, setPlanWarehouseId] = useState();
  const [scheduleTime, setScheduleTime] = useState();
  const [transactionType, setTransactionType] = useState();
  const [validationMessage, setValidationMessage] = useState('');
  const [validationMessageSuccess, setvalidationMessageSuccess] = useState('');
  const [shipmentType, setShipmentType] = useState('');
  const [shipmentTypeValue, setShipmentTypeValue] = useState('');
  const [grossWt, setGrossWt] = useState('');
  const [WId, setWId] = useState('');
  const [WDoor, setWDoor] = useState('');
  const [WName, setWName] = useState('');
  const [WAddress, setWAddress] = useState('');
  const [WCSZ, setWCSZ] = useState('');
  const [scac, setscac] = useState('');
  const [cName, setcName] = useState('');
  const [cEmail, setcEmail] = useState('');
  const [qtyUnits, setQtyUnits] = useState('');
  const [details, setdetails] = useState([]);
  const { user } = props.oidc;
  const accessToken = user ? user.access_token : '';
  const [selectedItemsApt, setSelectedItemsApt] = useState([searchpanel[0]]);
  const [selectedItemsShipment, setSelectedItemsShipment] = useState([searchpanel[0]]);
  const [selectedItemsConsignee, setSelectedItemsConsignee] = useState([searchpanel[0]]);
  const [selectedItemsWarehouse, setSelectedItemsWarehouse] = useState([searchpanel[0]]);
  const [selectedItemsCarrier, setSelectedItemsCarrier] = useState([searchpanel[0]]);
  const [selectedItemsDetails, setSelectedItemsDetails] = useState([searchpanel[0]]);
  const AptSelectionChanged = useCallback(
    (e) => {
      let newItems = [...selectedItemsApt];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItemsApt(newItems);
    },
    [selectedItemsApt, setSelectedItemsApt],
  );
  const ShipmentSelectionChanged = useCallback(
    (e) => {
      let newItems = [...selectedItemsShipment];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItemsShipment(newItems);
    },
    [selectedItemsShipment, setSelectedItemsShipment],
  );
  const ConsigneeSelectionChanged = useCallback(
    (e) => {
      let newItems = [...selectedItemsConsignee];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItemsConsignee(newItems);
    },
    [selectedItemsConsignee, setSelectedItemsConsignee],
  );
  const WarehouseSelectionChanged = useCallback(
    (e) => {
      let newItems = [...selectedItemsWarehouse];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItemsWarehouse(newItems);
    },
    [selectedItemsWarehouse, setSelectedItemsWarehouse],
  );
  const CarrierSelectionChanged = useCallback(
    (e) => {
      let newItems = [...selectedItemsCarrier];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItemsCarrier(newItems);
    },
    [selectedItemsCarrier, setSelectedItemsCarrier],
  );
  const DetailSelectionChanged = useCallback(
    (e) => {
      let newItems = [...selectedItemsDetails];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItemsDetails(newItems);
    },
    [selectedItemsDetails, setSelectedItemsDetails],
  );
  const handleToggleShipmentTypeCollapse = () => {
    setIsShipmentTypeCollapsed(!isShipmentTypeCollapsed);
  };
  const handleToggleScheduleAppointmentCollapse = () => {
    setIsScheduleAppointmentCollapsed(!isScheduleAppointmentCollapsed);
  };
  const handleToggleConsigneeCollapse = () => {
    setIsConsigneeCollapsed(!isConsigneeCollapsed);
  };
  const handleToggleWarehouseCollapse = () => {
    setIsWarehouseCollapsed(!isWarehouseCollapsed);
  };
  const handleToggleCarrierCollapse = () => {
    setIsCarrierCollapsed(!isCarrierCollapsed);
  };
  const handleToggleDetailsCollapse = () => {
    setDetailsCollapsed(!isDetailsCollapsed);
  };

  const styles = {
    '.MuiCard-root': {
      overflow: 'auto !important',
    },
    '.card-container': {
      height: '100% !important',
    },
    '.card': {
      width: '98% !important',
    },
  };
  const handleUpdate = async (e) => {
    setLoadPanelVisible(true);
    setValidationMessage('');
    setvalidationMessageSuccess('');
    setLoadIndicatorVisible(true);
    setButtonText('Sending');
    setButtonDisabled(true);
    console.log("transactionNumber" + transactionNumber);
    const url = `${window._env_.REACT_APP_APIS}/${data.DockDoor.Unschedule}`;
    const requestData = {
      transId: transactionNumber
    };

    try {
      const responseaaaaa = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(requestData),
      });
      if (!responseaaaaa.ok) {
        throw new Error('Failed to fetch schedule data');
      }
      const res = await responseaaaaa.json();
      console.log("res" + res.data);
      console.log("res" + res.success);
      if (res.success) {
        notify(
          {
            message: 'Appointment has been unscheduled successfully.',
            width: 600,
          },
          'success',
          3000,
        );
        RefereshPageAfterUnScheduleAppointment("Appointment has been unscheduled successfully.");
      } else {
        setValidationMessage(res.data);
      }

    } catch (err) {
      console.error('Data Loading Error:', err);
    } finally {
      setTimeout(hideLoadPanel, 1000);
    }
  }
  const RefereshPageAfterUnScheduleAppointment = async (msg) => {
    setLoadPanelVisible(true);
    try {
      const requestData = {
        formtransactionNumber: id,
      };
      const url = `${window._env_.REACT_APP_APIS}/${data.DockDoor.GetScheduleById}`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(requestData),
      });
      if (!response.ok) {
        throw new Error('Failed to fetch schedule data');
      }
      const result = await response.json();
      if (result && result.data) {
        console.log('Data:', result.data);
        if (result.data) {
          if (result.data.scheduleTrasantion) {
            if (result.data.scheduleTrasantion.transactionNumber !== null) {
              setTransactionNumber(result.data.scheduleTrasantion.transactionNumber);
            }
            if (result.data.scheduleTrasantion.shipperBol !== null) {
              setShipperBol(result.data.scheduleTrasantion.shipperBol);
            }
            if (result.data.scheduleTrasantion.delDateFrom !== null) {
              setDelDateFrom(result.data.scheduleTrasantion.delDateFrom);
            }
            if (result.data.scheduleTrasantion.delDateTo !== null) {
              setDelDateTo(result.data.scheduleTrasantion.delDateTo);
            }
            if (result.data.scheduleTrasantion.loadInfo !== null) {
              setLoadInfo(result.data.scheduleTrasantion.loadInfo);
            }
          }
          if (result.data.consigneeModel) {
            if (result.data.consigneeModel.consignee !== null) {
              setConsignee(result.data.consigneeModel.consignee);
            }
            if (result.data.consigneeModel.address1 !== null) {
              setConsigneeAddress1(result.data.consigneeModel.address1);
            }
            if (result.data.consigneeModel.address2 !== null) {
              setConsigneeAddress2(result.data.consigneeModel.address2);
            }
            if (result.data.consigneeModel.fullAddress !== null) {
              setConsigneeModelFullAddress(result.data.consigneeModel.fullAddress);
            }
          }
          if (result.data.loadingDateTime) {
            if (result.data.loadingDateTime.checkIn !== null) {
              setCheckIn(result.data.loadingDateTime.checkIn);
            }
            if (result.data.loadingDateTime.checkOut !== null) {
              setCheckOut(result.data.loadingDateTime.checkOut);
            }
          }

          if (result.data.planWarehouseId) {
            setPlanWarehouseId(result.data.planWarehouseId);
          }
          if (result.data.transactionType) {
            setTransactionType(result.data.transactionType);
          }
          if (result.data.shipmentType) {
            setShipmentType(result.data.shipmentType.type);
          }
          if (result.data.shipmentType) {
            setShipmentTypeValue(result.data.shipmentType.typeValue);
          }
          if (result.data.loadDetails) {
            setGrossWt(result.data.loadDetails.grossWt);
          }
          if (result.data.loadDetails) {
            setQtyUnits(result.data.loadDetails.qtyUnits);
          }
          if (result.data.warehouseDetails) {
            setWId(result.data.warehouseDetails.wId);
          }
          if (result.data.warehouseDetails) {
            setWDoor(result.data.warehouseDetails.wDoor);
          }
          if (result.data.warehouseDetails) {
            setWName(result.data.warehouseDetails.wName);
          }
          if (result.data.warehouseDetails) {
            setWAddress(result.data.warehouseDetails.wAddress);
          }
          if (result.data.warehouseDetails) {
            setWCSZ(result.data.warehouseDetails.wcsz);
          }
          if (result.data.carrier) {
            setscac(result.data.carrier.scac);
          }
          if (result.data.carrier) {
            setcName(result.data.carrier.cName);
          }
          if (result.data.carrier) {
            setcEmail(result.data.carrier.cEmail);
          }
          if (result.data.details) {
            setdetails(result.data.details);
          }
          setAppointmentDates('');
          setScheduleTime('');
          setButtonVisible(false);
          setvalidationMessageSuccess(msg);
        }
      }
    } catch (err) {
      console.error('Data Loading Error:', err);
      // You might want to handle the error more gracefully, e.g., show an error message to the user
    } finally {
      setTimeout(hideLoadPanel, 1000);
    }
  }
  const getScheduleById = async () => {
    setLoadPanelVisible(true);
    try {
      const requestData = {
        formtransactionNumber: id,
      };
      const url = `${window._env_.REACT_APP_APIS}/${data.DockDoor.GetScheduleById}`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(requestData),
      });
      if (!response.ok) {
        throw new Error('Failed to fetch schedule data');
      }
      const result = await response.json();
      if (result && result.data) {
        console.log('Data:', result.data);
        if (result.data) {
          if (result.data.scheduleTrasantion) {
            if (result.data.scheduleTrasantion.transactionNumber !== null) {
              setTransactionNumber(result.data.scheduleTrasantion.transactionNumber);
            }
            if (result.data.scheduleTrasantion.shipperBol !== null) {
              setShipperBol(result.data.scheduleTrasantion.shipperBol);
            }
            if (result.data.scheduleTrasantion.delDateFrom !== null) {
              setDelDateFrom(result.data.scheduleTrasantion.delDateFrom);
            }
            if (result.data.scheduleTrasantion.delDateTo !== null) {
              setDelDateTo(result.data.scheduleTrasantion.delDateTo);
            }
            if (result.data.scheduleTrasantion.loadInfo !== null) {
              setLoadInfo(result.data.scheduleTrasantion.loadInfo);
            }
          }
          if (result.data.consigneeModel) {
            if (result.data.consigneeModel.consignee !== null) {
              setConsignee(result.data.consigneeModel.consignee);
            }
            if (result.data.consigneeModel.address1 !== null) {
              setConsigneeAddress1(result.data.consigneeModel.address1);
            }
            if (result.data.consigneeModel.address2 !== null) {
              setConsigneeAddress2(result.data.consigneeModel.address2);
            }
            if (result.data.consigneeModel.fullAddress !== null) {
              setConsigneeModelFullAddress(result.data.consigneeModel.fullAddress);
            }
          }
          if (result.data.loadingDateTime) {
            if (result.data.loadingDateTime.checkIn !== null) {
              setCheckIn(result.data.loadingDateTime.checkIn);
            }
            if (result.data.loadingDateTime.checkOut !== null) {
              setCheckOut(result.data.loadingDateTime.checkOut);
            }
          }
          if (result.data.actualDelivery) {
            if (result.data.actualDelivery.date !== null) {
              setActualDeliveryDate(result.data.actualDelivery.date);
            }
            if (result.data.actualDelivery.time !== null) {
              setActualDeliveryTime(result.data.actualDelivery.time);
            }
          }

          if (result.data.alreadyScheduled) {
            const scheduledDate = new Date(result.data.alreadyScheduled);
            const formattedDate = scheduledDate.toISOString().split('T')[0]; // Extract date part
            const formattedTime = scheduledDate.toISOString().split('T')[1];
            setAppointmentDates(formattedDate);
            setScheduleTime(formattedTime);
          }
          if (result.data.scheduleAppointment) {
            setScheduleTime(result.data.scheduleAppointment.selectedTime);
          }


          if (result.data.planWarehouseId) {
            setPlanWarehouseId(result.data.planWarehouseId);
          }
          if (result.data.transactionType) {
            setTransactionType(result.data.transactionType);
          }
          if (result.data.shipmentType) {
            setShipmentType(result.data.shipmentType.type);
          }
          if (result.data.shipmentType) {
            setShipmentTypeValue(result.data.shipmentType.typeValue);
          }
          if (result.data.loadDetails) {
            setGrossWt(result.data.loadDetails.grossWt);
          }
          if (result.data.loadDetails) {
            setQtyUnits(result.data.loadDetails.qtyUnits);
          }
          if (result.data.warehouseDetails) {
            setWId(result.data.warehouseDetails.wId);
          }
          if (result.data.warehouseDetails) {
            setWDoor(result.data.warehouseDetails.wDoor);
          }
          if (result.data.warehouseDetails) {
            setWName(result.data.warehouseDetails.wName);
          }
          if (result.data.warehouseDetails) {
            setWAddress(result.data.warehouseDetails.wAddress);
          }
          if (result.data.warehouseDetails) {
            setWCSZ(result.data.warehouseDetails.wcsz);
          }
          if (result.data.carrier) {
            setscac(result.data.carrier.scac);
          }
          if (result.data.carrier) {
            setcName(result.data.carrier.cName);
          }
          if (result.data.carrier) {
            setcEmail(result.data.carrier.cEmail);
          }
          if (result.data.details) {
            setdetails(result.data.details);
          }

        }
      }
    } catch (err) {
      console.error('Data Loading Error:', err);
      // You might want to handle the error more gracefully, e.g., show an error message to the user
    } finally {
      setTimeout(hideLoadPanel, 1000);
    }
  };
  const hideLoadPanel = useCallback(() => {
    setLoadPanelVisible(false);
  }, [setLoadPanelVisible]);
  // Call the API on page load
  useEffect(() => {
    getScheduleById();
  }, [id, accessToken]);

  return (
    <div>
      <div className="row">
        <div className="col-md-12 main-page">
          <div className="row">
            <div className="col-md-12 main-page">
              <div id="accordion1">
                <AccordionReact
                  dataSource={searchpanel}
                  collapsible={true}
                  multiple={true}
                  animationDuration={300}
                  selectedItems={selectedItemsApt}
                  onSelectionChanged={AptSelectionChanged}
                  itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                      <Item location="before">
                        <div className="title">
                          <h6
                            style={{
                              color: window._env_.Color2
                            }}
                          >
                            Unschedule Appointment
                          </h6>
                        </div>
                      </Item>
                    </Toolbar>
                  )}
                  itemRender={(itemProps) => (
                    <div>
                      <div className="row accordianLastRow">
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Trans #"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={transactionNumber}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="ShipperBOL"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={shipperBol}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Del Date From"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={delDateFrom}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Del Date To"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={delDateTo}
                            readOnly={true}
                          />
                        </div>
                      </div>
                      <div className="row accordianLastRow">
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Consignee Address"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={consigneeModelFullAddress}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Load Info"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={loadInfo}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Loading Date Times Check-In"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={checkIn}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Loading Date Times Check-Out"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={checkOut}
                            readOnly={true}
                          />
                        </div>

                      </div>
                      <div className="row accordianLastRow">
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Actual Delivery Confirmation Date"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={actualDeliveryDate}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Appointment Date"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={appointmentDates}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Appointment Time"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={scheduleTime}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Actual Delivery Confirmation Time"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={actualDeliveryTime}
                            readOnly={true}
                          />
                        </div>

                      </div>
                      <div className="row" style={{ paddingTop: '10px' }}>
                        <div className="col-md-12">
                          {validationMessageSuccess && (
                            <div style={{
                              backgroundColor: '#d4edda',
                              color: '#155724',
                              padding: '10px',
                              borderRadius: '4px',
                              marginBottom: '10px',
                              border: '1px solid #c3e6cb'
                            }}>
                              {validationMessageSuccess}
                            </div>
                          )}

                          {validationMessage && (
                            <div style={{
                              backgroundColor: '#f8d7da',
                              color: '#721c24',
                              padding: '10px',
                              borderRadius: '4px',
                              marginBottom: '10px',
                              border: '1px solid #f5c6cb'
                            }}>
                              {validationMessage}
                            </div>
                          )}

                          {isButtonVisible && (
                            <Button
                              type="default"
                              onClick={handleUpdate}
                              disabled={isButtonDisabled}

                            >
                              Unschedule
                            </Button>
                          )}
                        </div>
                      </div>

                    </div>
                  )}
                  id="accordion-container1"

                />
              </div>
            </div>
          </div>
          <div className="row accordianLastRow">
            <div className="col-md-12 main-page">
              <div id="accordion1">
                <AccordionReact
                  dataSource={searchpanel}
                  collapsible={true}
                  multiple={true}
                  animationDuration={300}
                  selectedItems={selectedItemsShipment}
                  onSelectionChanged={ShipmentSelectionChanged}
                  itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                      <Item location="before">
                        <div className="title">
                          <h6
                            style={{
                              color: window._env_.Color2
                            }}
                          >
                            Shipment Type
                          </h6>
                        </div>
                      </Item>
                    </Toolbar>
                  )}
                  itemRender={(itemProps) => (
                    <div>
                      <div className="row accordianLastRow">

                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Type"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={shipmentType}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Type Value"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={shipmentTypeValue}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Gross Wt LBS"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={grossWt}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Qty Units"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={qtyUnits}
                            readOnly={true}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  id="accordion-container1"
                />
              </div>
            </div>
          </div>
          <div className="row accordianLastRow">
            <div className="col-md-12 main-page">
              <div id="accordion1">
                <AccordionReact
                  dataSource={searchpanel}
                  collapsible={true}
                  multiple={true}
                  animationDuration={300}
                  selectedItems={selectedItemsConsignee}
                  onSelectionChanged={ConsigneeSelectionChanged}
                  itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                      <Item location="before">
                        <div className="title">
                          <h6
                            style={{
                              color: window._env_.Color2
                            }}
                          >
                            Consignee
                          </h6>
                        </div>
                      </Item>
                    </Toolbar>
                  )}
                  itemRender={(itemProps) => (
                    <div>
                      <div className="row accordianLastRow">
                        <div className="col-md-6">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Consigness"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={consignee}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-6">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Address1"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={consigneeAddress1}
                            readOnly={true}
                          />
                        </div>

                      </div>
                      <div className="row accordianLastRow">
                        <div className="col-md-6">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Address2"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={consigneeAddress2}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-6">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="City State Zip"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={consigneeModelFullAddress}
                            readOnly={true}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  id="accordion-container1"

                />
              </div>
            </div>
          </div>
          <div className="row accordianLastRow">
            <div className="col-md-12 main-page">
              <div id="accordion1">
                <AccordionReact
                  dataSource={searchpanel}
                  collapsible={true}
                  multiple={true}
                  animationDuration={300}
                  selectedItems={selectedItemsWarehouse}
                  onSelectionChanged={WarehouseSelectionChanged}
                  itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                      <Item location="before">
                        <div className="title">
                          <h6
                            style={{
                              color: window._env_.Color2
                            }}
                          >
                            Warehouse
                          </h6>
                        </div>
                      </Item>
                    </Toolbar>
                  )}
                  itemRender={(itemProps) => (
                    <div>
                      <div className="row accordianLastRow">

                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="ID"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={WId}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Dock/Door"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={WDoor}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-6">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Name"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={WName}
                            readOnly={true}
                          />
                        </div>

                      </div>
                      <div className="row accordianLastRow">

                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="City State Zip"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={WCSZ}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-9">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Address"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={WAddress}
                            readOnly={true}
                          />
                        </div>
                      </div>


                    </div>
                  )}
                  id="accordion-container1"

                />
              </div>
            </div>
          </div>
          <div className="row accordianLastRow">
            <div className="col-md-12 main-page">
              <div id="accordion1">
                <AccordionReact
                  dataSource={searchpanel}
                  collapsible={true}
                  multiple={true}
                  animationDuration={300}
                  selectedItems={selectedItemsCarrier}
                  onSelectionChanged={CarrierSelectionChanged}
                  itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                      <Item location="before">
                        <div className="title">
                          <h6
                            style={{
                              color: window._env_.Color2
                            }}
                          >
                            Carrier
                          </h6>
                        </div>
                      </Item>
                    </Toolbar>
                  )}
                  itemRender={(itemProps) => (
                    <div>

                      <div className="row accordianLastRow">

                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Carrier(SCAC)"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={scac}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-6">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="Name"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={cName}
                            readOnly={true}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextBox
                            stylingMode='outlined'
                            labelMode="static"
                            label="e-mail"
                            defaultValue=""
                            style={{ width: '100%' }}
                            value={cEmail}
                            readOnly={true}
                          />
                        </div>

                      </div>

                    </div>
                  )}
                  id="accordion-container1"

                />
              </div>
            </div>
          </div>
          <div className="row accordianLastRow">
            <div className="col-md-12 main-page">
              <div id="accordion1">
                <AccordionReact
                  dataSource={searchpanel}
                  collapsible={true}
                  multiple={true}
                  animationDuration={300}
                  selectedItems={selectedItemsDetails}
                  onSelectionChanged={DetailSelectionChanged}
                  itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                      <Item location="before">
                        <div className="title">
                          <h6
                            style={{
                              color: window._env_.Color2
                            }}
                          >
                            Details
                          </h6>
                        </div>
                      </Item>
                    </Toolbar>
                  )}
                  itemRender={(itemProps) => (
                    <div>
                      <div className="row" style={{ marginTop: '10px' }}>
                        <div className="col-md-9">
                          <div style={{ overflowX: 'auto' }}>
                            <table style={{
                              width: '100%',
                              borderCollapse: 'collapse',
                              fontSize: '14px'
                            }}>
                              <thead style={{ backgroundColor: '#f9f9f9' }}>
                                <tr style={{ borderBottom: '1px solid #ddd' }}>
                                  <th style={{ textAlign: 'left', padding: '8px' }}>Item</th>
                                  <th style={{ textAlign: 'left', padding: '8px' }}>Lot</th>
                                  <th style={{ textAlign: 'left', padding: '8px' }}>Call Off / PO</th>
                                  <th style={{ textAlign: 'left', padding: '8px' }}>Qty</th>
                                </tr>
                              </thead>
                              <tbody>
                                {details.map((item, index) => (
                                  <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                                    <td style={{ padding: '8px' }}>{item.item}</td>
                                    <td style={{ padding: '8px' }}>{item.lot}</td>
                                    <td style={{ padding: '8px' }}>{item.callOffPO}</td>
                                    <td style={{ padding: '8px' }}>{item.qty}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  id="accordion-container1"

                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(UnScheduleAppointment);
